import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { Plan } from './plan.model';
import { Planner } from './planner.model';

/**
 * Loader contract used by PlannerComponent to fetch plans for a date range.
 *
 * Default binding is PlannerService (authenticated, /my/planners/...).
 * Public/share contexts provide their own implementation that hits the
 * unauthenticated /api/planners/:id/plans endpoint.
 */
export interface PlannerPlanLoader {
  getPlanForDateRange$(planner: Planner, startDate: string, endDate: string): Observable<Plan[]>;
}

export const PLANNER_PLAN_LOADER = new InjectionToken<PlannerPlanLoader>('PlannerPlanLoader');
